import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { LcsCallStatePipeModule } from '@lcs/shared/call-state-pipe';
import { LcsDatepickerModule } from '@lcs/shared/datepicker';
import { LcsLoadingOverlayModule } from '@lcs/shared/loading-overlay';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { AppRoutingModule } from 'src/app/app-routing.module';
import { CardLayoutModule } from 'src/app/common-components/card-layout/card-layout.module';
import { TwoColumnLayoutModule } from 'src/app/common-components/column-layouts/two-column-layout/two-column-layout.module';
import { ResizeOnTabChangeDirectiveModule } from 'src/app/common-components/detail/resize-on-tab-change-directive.module';
import { TabRouterDirectiveModule } from 'src/app/common-components/detail/tab-router-directives.module';
import { EntitySelectModule } from 'src/app/common-components/entity-select/entity-select.module';
import { LcsSingleSelectModule } from 'src/app/common-components/entity-select/single-select/single-select.module';
import { FileUploadModule } from 'src/app/common-components/file-upload/file-upload.module';
import { FormFooterModule } from 'src/app/common-components/form-footer/form-footer.module';
import { UpdateDetailsModule } from 'src/app/common-components/update-details/update-details.module';
import { FileUrlPipeModule } from 'src/app/pipes/file-url-pipe/file-url-pipe.module';
import { LocationModule } from 'src/app/pipes/location/location.module';
import { AddSpacesPipeModule } from 'src/app/pipes/split-enum-strings/add-spaces-pipe.module';
import { ErrorPageModule } from '../error-page/error-page.module';
import { ExtensionRegisterModule } from '../extension-register/extensions-register.module';
import { PhoneNumberRegisterModule } from '../phone-number-register/phone-number-register.module';
import { LocationDetailComponent } from './containers/location-detail.component';
import { LocationDetailEffects } from './state/location-detail.effects';
import * as fromLocationDetail from './state/location-detail.reducer';
import { LocationDetailViewComponent } from './views/location-detail-view.component';

@NgModule({
   declarations: [LocationDetailViewComponent, LocationDetailComponent],
   exports: [LocationDetailComponent],
   imports: [
      CommonModule,
      FormsModule,
      MatFormFieldModule,
      ReactiveFormsModule,
      MatCheckboxModule,
      RouterModule,
      MatInputModule,
      MatIconModule,
      MatMenuModule,
      MatButtonModule,
      MatTooltipModule,
      LcsLoadingOverlayModule,
      LcsCallStatePipeModule,
      LcsDatepickerModule,
      TwoColumnLayoutModule,
      FormFooterModule,
      MatSelectModule,
      LocationModule,
      LcsSingleSelectModule,
      EntitySelectModule,
      MatTabsModule,
      ExtensionRegisterModule,
      PhoneNumberRegisterModule,
      StoreModule.forFeature(fromLocationDetail.locationDetailFeatureKey, fromLocationDetail.reducer),
      EffectsModule.forFeature([LocationDetailEffects]),
      AppRoutingModule,
      UpdateDetailsModule,
      FileUploadModule,
      FileUrlPipeModule,
      AddSpacesPipeModule,
      CardLayoutModule,
      ErrorPageModule,
      TabRouterDirectiveModule,
      ResizeOnTabChangeDirectiveModule,
   ],
})
export class LocationDetailModule {}
